import { createContext, useContext, type ReactNode } from "react";

export type SystemModelContextValue = {
  /** True si la page éditée est un modèle système (pas une page éditoriale). */
  isSystemModel: boolean;
  /** Libellé métier court (ex. « Fiche rubrique », « En-tête »). */
  kindLabel: string | null;
};

const SystemModelContext = createContext<SystemModelContextValue>({
  isSystemModel: false,
  kindLabel: null,
});

export function SystemModelProvider({
  value,
  children,
}: {
  value: SystemModelContextValue;
  children: ReactNode;
}) {
  return (
    <SystemModelContext.Provider value={value}>
      {children}
    </SystemModelContext.Provider>
  );
}

export function useSystemModel(): SystemModelContextValue {
  return useContext(SystemModelContext);
}
